import React from "react";
import PropTypes from "prop-types";
import { TableBody } from "@mui/material";
import TaskDetailContext from "contexts/TaskDetailContext";
import ModelTaskRow from "./ModelTaskRow";
import ModelTaskTableBodyRow from "./ModelTaskTableBodyRow";
import PreviousPageRow from "./PreviousPageRow";
import EndOfListRow from "./EndOfListRow";
import EmptyStateRow from "./EmptyStateRow";
import NextPageStatusRow from "./NextPageStatusRow";

const noop = () => {};

const VirtualModelTaskRows = ({
	rows,
	virtualRows,
	virtualizer,
	topPadding,
	bottomPadding,
	expandedIds,
	onExpandedChange,
	columns,
	classes,
	data,
	rowProps,
	previousPage,
	nextPage,
	showSelection,
	selection,
	changedIds,
	onGoToTop,
}) => {
	const columnCount = columns.length + (showSelection ? 1 : 0);

	return (
		<>
			<PreviousPageRow previousPage={previousPage} columnCount={columnCount} classes={classes} />
			<ModelTaskTableBodyRow height={topPadding} columnCount={columnCount} />
			{virtualRows.map((virtualRow) => {
				const tableRow = rows[virtualRow.index];
				const task = tableRow.original;
				return (
					<TableBody
						key={tableRow.id}
						data-index={virtualRow.index}
						ref={virtualizer.measureElement}
					>
						<TaskDetailContext taskId={task.id}>
							<ModelTaskRow
								{...rowProps}
								row={task}
								index={virtualRow.index}
								rowIndex={virtualRow.index + 2}
								isExpanded={expandedIds.has(task.id)}
								onExpandedChange={onExpandedChange}
								showSelection={showSelection}
								isRowSelected={selection.isSelected(task.id)}
								onSelectedChange={selection.toggleRow}
								isRecentlyChanged={changedIds.has(task.id)}
								classes={classes}
								columns={columns}
								data={data}
								originalRow={task}
								updatedFieldFunc={noop}
							/>
						</TaskDetailContext>
					</TableBody>
				);
			})}
			<ModelTaskTableBodyRow height={bottomPadding} columnCount={columnCount} />
			<EndOfListRow
				hasNextPage={nextPage.hasPage}
				dataLength={data.length}
				columnCount={columnCount}
				classes={classes}
				onGoToTop={onGoToTop}
			/>
			<EmptyStateRow dataLength={data.length} columnCount={columnCount} />
			<NextPageStatusRow nextPage={nextPage} columnCount={columnCount} classes={classes} />
		</>
	);
};

VirtualModelTaskRows.propTypes = {
	rows: PropTypes.array.isRequired,
	virtualRows: PropTypes.array.isRequired,
	virtualizer: PropTypes.shape({ measureElement: PropTypes.func.isRequired }).isRequired,
	topPadding: PropTypes.number.isRequired,
	bottomPadding: PropTypes.number.isRequired,
	expandedIds: PropTypes.instanceOf(Set).isRequired,
	onExpandedChange: PropTypes.func.isRequired,
	columns: PropTypes.arrayOf(PropTypes.string).isRequired,
	classes: PropTypes.object.isRequired,
	data: PropTypes.array.isRequired,
	rowProps: PropTypes.object.isRequired,
	previousPage: PropTypes.shape({
		hasPage: PropTypes.bool.isRequired,
		isFetching: PropTypes.bool.isRequired,
		isError: PropTypes.bool.isRequired,
		fetch: PropTypes.func.isRequired,
	}).isRequired,
	nextPage: PropTypes.shape({
		hasPage: PropTypes.bool.isRequired,
		isFetching: PropTypes.bool.isRequired,
		isError: PropTypes.bool.isRequired,
		fetch: PropTypes.func.isRequired,
	}).isRequired,
	showSelection: PropTypes.bool.isRequired,
	selection: PropTypes.shape({
		isSelected: PropTypes.func.isRequired,
		toggleRow: PropTypes.func.isRequired,
	}).isRequired,
	changedIds: PropTypes.instanceOf(Set).isRequired,
	onGoToTop: PropTypes.func.isRequired,
};

export default VirtualModelTaskRows;
